<section id="front_wrap">
  <section id="front_page" class="profile_step">
    <section id="menu_front">
    <span class="badge badge-danger" *ngIf="takeInHand && takeInHand === 'yes'">
        <h6 style="color: #ffffff;font-size: 12px;">
        <span class="bx bx-info-circle"></span> {{'messages.accountControlActive' | translate}} <br>{{'messages.ofThisAccount' | translate}}
       </h6>
         <button type="button" class="btn btn-primary waves-effect waves-light" (click)="returner(admin_login)">
            {{'header.returnPreviousAccount' | translate}}
          </button>
      </span>
      <a class="menu_item menu_search" href="dashboard/inspector"><img src="assets/img/icon_search.png"> <p>{{'inspector.search' | translate}}</p></a>
      <a class="menu_item menu_profile" href="dashboard/inspector/profile"><img src="assets/img/icon_profile.png"> <p>{{'fields.profile' | translate}}</p></a>
      <a class="menu_item menu_export current" href="dashboard/inspector/inspector-export.html"><img src="assets/img/icon_profile.png"> <p>{{'common.export' | translate}}</p></a>
      <a (click)="logout_user()" class="menu_item menu_logout" ><img src="assets/img/icon_logout.png"> <p>{{'header.logout' | translate}}</p></a>
    </section>
    <ngx-spinner
      bdColor="rgba(51,51,51,0.8)"
      size="medium"
      color="#fff"
      type="ball-scale-multiple"  >
      <p style="font-size: 20px; color: white">{{'messages.exporting' | translate}}</p>
    </ngx-spinner>
    <div class="main-content"   style="width: 50%">
      <div class="page-content">
        <div class="container-fluid">
          <!-- start page title -->
          <div class="row">
            <div class="col-12">
              <div class="page-title-box d-flex align-items-center justify-content-between">
                <h4 class="mb-0 font-size-18">
                  <i class="bx bx-home-circle"></i>  {{'dashboard.welcome' | translate}}
                  <app-fildariane></app-fildariane>
                </h4>
              </div>
            </div>
          </div>
          <!-- end page title -->
          <!-- end row -->
          <div class="row">
            <div class="card col-xl-12">
              <div class="card-body">
                <h4 class="card-title mb-4">{{'common.export' | translate}}</h4>
                <div class="alert alert-success text-center" role="alert" *ngIf="successMessage">
                  {{text}}.
                  <button type="button" class="close" data-dismiss="alert" [attr.aria-label]="'common.close' | translate">
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <label class="col-md-12col-form-label">{{'messages.selectExportData' | translate}}</label>
                <div>
                  <div class="form-group row">
                    <div class="col-md-9">
                      <select class="custom-select" [(ngModel)]="exportate.type" (change)="chooseType($event)">
<!--                          <option value="7">Vérification</option>-->
                      </select>
                    </div>
                  </div>
                  <ng-container *ngIf="choose && choose==7">
                    <label class="col-form-label">{{'messages.selectVerification' | translate}}</label>
                    <div class="form-group row">
                      <div class="col-md-9">
                        <select class="custom-select" (change)="chooseVerifications($event)">
                        </select>
                      </div>
                    </div>
                  </ng-container>
                  <div class="alert alert-danger" role="alert" *ngIf="messeNotUser">
                    {{'export.noLearners' | translate}}
                  </div>
                  <ng-container *ngIf="choose && choose!=-1">
                    <div class="form-group row">
                      <div class="form-group text-center">
                        <button type="button" class="btn btn-primary waves-effect waves-light" (click)="exportation()">
                          {{'common.export' | translate}}
                        </button>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <!-- end card -->

            <!-- end card -->
          </div>

        </div>
        <!-- end row -->
      </div>
      <!-- container-fluid -->
    </div>
  </section>
  <div id="front_legal">
    <p>CERTIKAP - par <strong>Kaptitude</strong> - 2020</p>
  </div>
</section>


